import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {Tag} from 'primeng/tag';
import {Severity} from '../../enum-to-tag';
import {CopyButtonComponent} from '../copy-button/copy-button.component';

@Component({
  selector: 'homey-labeled',
  imports: [Tag, CopyButtonComponent],
  templateUrl: './labeled.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LabeledComponent<T extends string> {
  public readonly label = input.required<string>();
  public readonly value = input.required<T | undefined | null>();
  public readonly copy = input<boolean>(false);
  public readonly tagFunction = input<(value: T) => Severity>();
}
